export const formatUnitDimensions = (width: number, length: number) => {
    const hasWidth = width !== 0;
    const hasLength = length !== 0;
    return hasWidth && hasLength
        ? `${width}' x ${length}'`
        : hasWidth
          ? `${width}'`
          : hasLength
            ? `${length}'`
            : "";
};
